import { useContext } from "react";
import { ApiContext } from "../../contexts/ApiContext";
import { useMutation } from "react-query";
import { QueryCallbacks } from "../../shared/interfaces/ReactQuery";
import { EditableReusableCustomQuestion } from "../../shared/interfaces/ReusableCustomQuestionField";

export function useCustomQuestionFieldUpdate(callbacks?: QueryCallbacks<number>) {
  const apiContext = useContext(ApiContext);
  return useMutation(
    ["customQuestionFieldUpdate"],
    async (customQuestionField: EditableReusableCustomQuestion) =>
      apiContext.customWorkflowQuestionApis.updateCustomQuestionField(customQuestionField),
    {
      onSuccess: callbacks?.onSuccess,
      onError: callbacks?.onError,
    },
  );
}
